import { c as _c } from "react/compiler-runtime";
import * as stylex from "@stylexjs/stylex";
const Root = "div";
export function Action(props) {
  const $ = _c(9);
  let label;
  let rest;
  if ($[0] !== props) {
    ({
      label,
      ...rest
    } = props);
    $[0] = props;
    $[1] = label;
    $[2] = rest;
  } else {
    label = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="x1wsuqlk x1kky2od"><svg className="x1lliihq x1kky2od xlup9mm" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg></div>;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== label) {
    t1 = <div className="x1dcheo9 xd85mq3">{label}</div>;
    $[4] = label;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== rest || $[7] !== t1) {
    t2 = <Root {...rest} className="xjbqb8w xvc674v xuxw1ft x78zum5 x6s0dn4 x17zmd2n xwvwv9b x1q0g3np x1iyjqo2 xs83m0k xdl72j9 xb3r6kr xqin4a2 xcym7qx xt0e3qv x1d6mti2">{t0}{t1}</Root>;
    $[6] = rest;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}